import { useSitewideMessage } from '@percent/cause-dashboard/common/hooks'
import { CentralCardLayout, CentralCardLayoutProps } from '@percent/domain/iam'
import { Footer, CausesPortalLogo, LocalePicker } from '@percent/cause-dashboard/common/components'

type CentralCardLayoutWrapperProps = CentralCardLayoutProps & {
  hideLocalePicker?: boolean
}

export function CentralCardLayoutWrapper(props: Readonly<CentralCardLayoutWrapperProps>) {
  const { shouldShowSitewideMessage } = useSitewideMessage()
  const { hideLocalePicker } = props

  return (
    <CentralCardLayout
      {...props}
      footer={<Footer />}
      isRebrandBanner={shouldShowSitewideMessage}
      logoHref={<CausesPortalLogo isCardLayout />}
      localePicker={!hideLocalePicker ? <LocalePicker /> : undefined}
    />
  )
}
